import { useEffect } from 'react';

const SITE_NAME = 'Paw Global Veterinary';
const DEFAULT_TITLE =
  'Paw Global Veterinary - Comprehensive Pet Care Services in Phnom Penh, Cambodia';

/** Sets the browser tab title for the current page. */
export default function usePageTitle(pageTitle) {
  useEffect(() => {
    document.title = pageTitle ? `${pageTitle} | ${SITE_NAME}` : DEFAULT_TITLE;
  }, [pageTitle]);
}
